import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';

import PlatformItem from './PlatformItem/PlatformItem';

import classes from './PlatformItems.module.scss';

const PlatformItems = ({ items }) => {
  const { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <section className={classes.wrap}>
      {items.map(item =>
        item.disabled ? (
          <div className={classes.link} key={item.title}>
            <PlatformItem item={item} />
          </div>
        ) : (
          <Fragment key={item.title}>
            {!item.url2 ? (
              <NavLink
                to={generateRegionalPath(`${url}/${item.url}`)}
                key={item.title}
                className={classes.link}
              >
                <PlatformItem item={item} />
              </NavLink>
            ) : (
              <div className={classes.link}>
                <PlatformItem item={item} />
              </div>
            )}
          </Fragment>
        )
      )}
    </section>
  );
};

PlatformItems.propTypes = {
  items: PropTypes.array
};

export default PlatformItems;
